import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Button, Typography } from '@mui/material';
import BusinessVerification from '../BusinessVerification';
import { useAuth } from '../../../context/AuthContext';

function Step8Verification({ _formData, businessId, onComplete: _onComplete, onError }) {
  const navigate = useNavigate();
  const { user } = useAuth();
  const [needsLogin, setNeedsLogin] = React.useState(false);

  // Redirect to verification only when user has valid session (no token restore from formData)
  React.useEffect(() => {
    if (!businessId) {
      if (onError) {
        onError(new Error('Business ID is required for verification'));
      }
      return;
    }

    const token = localStorage.getItem('token');
    const isAuthenticated = token && user?.role === 'supplier';

    if (isAuthenticated) {
      navigate(`/supplier/verification/${businessId}`, { replace: true });
    } else {
      setNeedsLogin(true);
    }
  }, [businessId, navigate, onError, user?.role]);

  if (needsLogin) {
    return (
      <Box sx={{ p: 3, textAlign: 'center' }}>
        <Typography variant="body1" sx={{ mb: 2 }}>
          You have saved verification progress. Please log in to continue.
        </Typography>
        <Button variant="contained" onClick={() => navigate('/supplier/login', { state: { from: { pathname: '/supplier/register' } } })}>
          Log in
        </Button>
      </Box>
    );
  }

  return (
    <BusinessVerification />
  );
}

export default Step8Verification;

